import classNames from 'classnames';
import { OTPInput, OTPInputProps, SlotProps } from 'input-otp';

const FakeCaret = () => {
  return (
    <div className="absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink">
      <div className="w-px h-[1.375rem] bg-technical-cursor" />
    </div>
  );
};

const Slot = ({ char, hasFakeCaret, isActive, isError }: SlotProps & { isError?: boolean }) => {
  return (
    <div
      className={classNames(
        'msq-input p-0 w-10 h-12 relative flex items-center justify-center text-caption-lg-a',
        {
          'msq-input-focus': !isError && isActive,
          'msq-input-error': isError,
        },
      )}
    >
      {char !== null && <span>{char}</span>}
      {hasFakeCaret && <FakeCaret />}
    </div>
  );
};

export type OtpInputProps = Omit<OTPInputProps, 'children'> & {
  isError?: boolean;
};

export const OtpInput = ({ containerClassName, isError, ...props }: OtpInputProps) => {
  return (
    <OTPInput
      {...props}
      // note props.className is set on hidden input
      containerClassName={classNames('group test flex gap-2 items-center', containerClassName)}
      render={({ slots }) => (
        <>
          {slots.map((slot, idx) => (
            <Slot isError={isError} key={idx} {...slot} />
          ))}
        </>
      )}
    />
  );
};
